<template>
    <div>
        <b-modal :no-close-on-backdrop="true" body-class="px-0" id="modal-Check-FollowUp" title="Remark" hide-footer :centered="true" v-model="open">
            <div class="pl-20 pr-20">
                <b-form-group label="Remarks" class="clear-both text-remark notFloat">
                    <b-form-textarea :disabled="checkEditChecklist()" v-model="checkListItem.follow_up.description" class="notFloat" rows="4"></b-form-textarea>
                </b-form-group>
                <b-form-group label="photos" class="photosThumb clear-both">
                    <ul class="list-thumb">
                        <li v-for="(item,key) in checkListItem.follow_up.attachments" v-bind:key="key">
                            <img v-auth-image="item.url.thumb" src="img/loading.gif" :alt="item.image_file_name || 'image'" />
                            <span v-if="!checkEditChecklist()" class="delete" @click="deleteFollowUp(item)">
                                <img src="img/close.png" alt />
                            </span>
                        </li>
                    </ul>
                    <div class="upload-btn-wrapper">
                        <b-form-file :disabled="checkEditChecklist()" id="fileInputMulti" v-model="imgFollowUp" :plain="true" :multiple="true"></b-form-file>
                        <gofix-button :disabled="checkEditChecklist()" class="m-3" label="add photo" outline></gofix-button>
                    </div>
                </b-form-group>
            </div>
            <b-button-group class="d-block text-right pl-10 pr-10">
                <gofix-button v-if="item && item.safety_remark && item.safety_remark.id" @click="resetRemark" :loading="isDeleteAction" :disabled="checkEditChecklist()" label="DELETE" class="mr-3 pull-left mt-10" noBorder></gofix-button>
                <gofix-button :disabled="checkEditChecklist()" label="APPLY" @click="updateRemark" :loading="isAction" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        name: 'modal-remark-follow-up',
        components: {
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            item: {
                type: Object,
                default: () => {}
            },
            job: {
                type: Object,
                default: () => {}
            },
            typeJob: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                open: false,
                checkListItem: {
                    follow_up: {
                        description: "",
                        remark_type: "JobFollowUp",
                        attachments: [],
                    },
                },
                isAction: false,
                isDeleteAction: false,
                imgActionTaken: null,
                imgActionTakenAction: {
                    photos: [],
                    delete: [],
                },
                imgFollowUpAction: {
                    photos: [],
                    delete: [],
                },
                imgFollowUp: null,
                iskeepNextJob: false,
                modal: {
                    sla: {
                        open: false,
                        loading: false,
                        service_category_id: null
                    },
                }
            }
        },
        mounted() {},
        created() {},
        watch: {
            open: function(val) {
                this.$emit('input', val);
                if(val) {
                    this.iskeepNextJob = false
                    this.checkListItem.follow_up = {
                        description: "",
                        remark_type: "JobSafetyRemarks",
                        attachments: [],
                    }
                    if(this.item) {
                        let tmp = JSON.parse(JSON.stringify(this.item));
                        this.checkListItem.follow_up = Object.assign(this.checkListItem.follow_up, tmp.safety_remark)
                    }
                }
            },
            value: function(val) {
                this.open   = val;
            },
            imgFollowUp(val, old) {
                if (val) {
                    val.forEach((file) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment: moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            },
                        };
                        this.imgFollowUpAction.photos.push(file);
                        this.checkListItem.follow_up.attachments.push(data);
                    });
                }
            },
            imgActionTaken(val) {
                if (val) {
                    val.forEach((file, index) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf() + index;
                        let data = {
                            moment: moment().valueOf() + index,
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            },
                        };
                        this.imgActionTakenAction.photos.push(file);
                        this.checkListItem.action_taken_photos.push(data);
                    });
                }
            },
        },
        methods: {
            checkEditChecklist() {
                if(!this.job || !this.job.status) return true;
                return false
            },
            updateRemark() {
                if (this.isAction) return;
                this.isAction = true;
                let data = {
                    id: this.item.id,
                    data: this.checkListItem.follow_up,
                    action: this.imgFollowUpAction,
                    safety_remark_id: this.item.safety_remark_id,
                };
                this.updated(data);
            },
            updated(data) {
                this.$store
                    .dispatch("SafetyAppController/checklistEntriesFollowUp", data)
                    .then((result) => {
                        this.imgFollowUpAction = { photos: [], delete: [] };
                        this.imgActionTakenAction = { photos: [], delete: [] };
                        this.$alertNotification(this.$notificationV2("editing", "checklist"));
                        this.isAction = false;
                        this.isDeleteAction = false;
                        this.open = false;
                        this.$emit('reloadChecklist', result.data.data)
                    })
                    .catch((error) => {
                        this.isAction = false;
                        this.isDeleteAction = false;
                    });
            },
            deleteFollowUp(img) {
                if (img.moment) {
                    this.checkListItem.follow_up.attachments = this.checkListItem.follow_up.attachments.filter(
                        (item) => item.moment != img.moment
                    );
                    this.imgFollowUpAction.photos = this.imgFollowUpAction.photos.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.checkListItem.follow_up.attachments = this.checkListItem.follow_up.attachments.filter(
                        (item) => item.id != img.id
                    );
                    this.$store.dispatch("SafetyAppController/deleteAttachments", {
                        ids: [img.id]
                    }).then((result) => {
                        this.$emit('reloadChecklist')
                    })
                }
            },
            resetRemark(){
                if (this.isDeleteAction) return;
                this.isDeleteAction = true;
                let data = {
                    id: this.item.id,
                    data: {
                        description: null
                    },
                    action: [],
                    safety_remark_id: null,
                };
                
                this.updated(data);
            }
        }
    }
</script>
